import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageMeta from '@/components/base/PageMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';

const milestones = [
  { year: '2018', title: '网站创立', desc: '白菜网站正式上线，立志成为最值得信赖的白菜优惠信息聚合平台。' },
  { year: '2019', title: '用户破10万', desc: '凭借真实可靠的优惠信息，注册用户突破10万，日活跃用户超过1万。' },
  { year: '2020', title: '内容升级', desc: '引入分类体系和智能推荐算法，用户体验大幅提升，覆盖品类扩展至全行业。' },
  { year: '2021', title: '用户破50万', desc: '平台用户突破50万，成为中文互联网最受欢迎的白菜优惠信息平台之一。' },
  { year: '2022', title: '品牌合作', desc: '与京东、淘宝、拼多多等主流电商平台建立合作关系，优惠信息来源更加丰富。' },
  { year: '2024', title: '全新升级', desc: '网站全新改版，更快的更新速度，更全的优惠信息，更好的用户体验。' },
];

const teamMembers = [
  { name: '张伟', role: '创始人 & CEO', desc: '十年互联网行业经验，前大型电商平台产品经理，对优惠信息有着敏锐的洞察力。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20male%20professional%20in%20casual%20business%20attire%2C%20warm%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20friendly%20and%20approachable%20expression%2C%20clean%20minimalist%20editorial%20portrait%20photography&width=160&height=160&seq=team-member-01&orientation=squarish' },
  { name: '李娜', role: '内容总监', desc: '资深消费领域编辑，曾任多家知名媒体消费板块主编，拥有丰富的行业资源。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20female%20professional%20in%20smart%20casual%20attire%2C%20warm%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20friendly%20and%20confident%20expression%2C%20clean%20minimalist%20editorial%20portrait%20photography&width=160&height=160&seq=team-member-02&orientation=squarish' },
  { name: '王磊', role: '技术负责人', desc: '全栈工程师，专注于高性能Web应用开发，确保网站稳定快速地服务每一位用户。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20male%20tech%20professional%20in%20casual%20style%2C%20warm%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20friendly%20and%20thoughtful%20expression%2C%20clean%20minimalist%20editorial%20portrait%20photography&width=160&height=160&seq=team-member-03&orientation=squarish' },
  { name: '陈静', role: '运营经理', desc: '擅长社群运营和用户增长，致力于打造活跃的白菜爱好者社区。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20female%20marketing%20professional%20in%20modern%20attire%2C%20warm%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20friendly%20and%20energetic%20expression%2C%20clean%20minimalist%20editorial%20portrait%20photography&width=160&height=160&seq=team-member-04&orientation=squarish' },
];

export default function About() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormSubmitted(true);
      return;
    }
    const name = (formData.get('name') as string || '').trim();
    const email = (formData.get('email') as string || '').trim();
    const message = (formData.get('message') as string || '').trim();

    if (!name || !email || !message) {
      setFormError('请填写所有必填字段。');
      return;
    }
    if (message.length > 500) {
      setFormError('留言内容不能超过500个字符。');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9snn4llbrt1qcgaj6kg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ name, email, message }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch (_) { /* ignore parse error */ }
      if (res.ok && parsed?.code === 'OK') {
        setFormSubmitted(true);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
        setFormError(serverMsg.includes('spam') ? '提交失败，请稍后重试。' : (serverMsg || '提交失败，请稍后重试。'));
      }
    } catch {
      setFormError('网络错误，请检查网络后重试。');
    }
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '白菜网站',
        url: 'https://www.baicaiwang.com/',
        description: '汇聚全网最新白菜价商品、0元购活动、限时免费领取优惠，帮你第一时间抢到最新白菜好物，省钱攻略一网打尽。',
        foundingDate: '2018',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'contact@baicaiwang.com',
          availableLanguage: 'Chinese',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 白菜网站',
        description: '了解白菜网站的品牌故事、发展历程、团队介绍和联系方式。汇聚全网最新白菜优惠信息的信赖之选。',
        url: 'https://www.baicaiwang.com/about',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.baicaiwang.com/' },
            { '@type': 'ListItem', position: 2, name: '关于我们' },
          ],
        },
      },
    ],
  };

  return (
    <>
      <PageMeta
        title="关于我们 - 白菜网站"
        description="了解白菜网站的品牌故事、发展历程、团队介绍和联系方式。汇聚全网最新白菜优惠信息的信赖之选，每日更新白菜价商品和优惠活动。"
        keywords="白菜网站,关于我们,白菜网站介绍,白菜优惠,联系我们"
        canonicalUrl="https://www.baicaiwang.com/about"
      />
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />

      <main>
        <div className="w-full px-4 md:px-6 py-6 bg-background-50 border-b border-background-200/70">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        {/* Brand Intro */}
        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mb-6">
              <i className="ri-price-tag-3-line text-2xl"></i>
            </span>
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-5">
              关于白菜网站
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              白菜网站成立于2018年，是国内领先的白菜价商品与优惠活动信息聚合平台。
              我们致力于为广大消费者提供<strong className="text-primary-600">最新、最全、最真实</strong>的优惠信息，
              帮助每一位用户用最低的价格买到心仪的商品。
            </p>
          </div>
        </section>

        {/* Mission & Values */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 mb-4">
                  <i className="ri-eye-line text-xl"></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">我们的愿景</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一位消费者都能轻松找到最实惠的购物机会，省钱也能省心。
                </p>
              </div>
              <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4">
                  <i className="ri-shield-check-line text-xl"></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">我们的承诺</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有优惠信息均来自官方渠道，真实可靠，绝无虚假信息。
                </p>
              </div>
              <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-500 mb-4">
                  <i className="ri-flashlight-line text-xl"></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">我们的速度</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  实时监控各大平台优惠动态，第一时间推送最新白菜信息。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 text-center mb-10">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300/60 md:-translate-x-px"></div>
              <div className="space-y-8">
                {milestones.map((item, idx) => (
                  <div key={idx} className={`relative flex flex-col md:flex-row gap-4 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className="md:w-1/2"></div>
                    <div className="absolute left-4 md:left-1/2 w-2.5 h-2.5 rounded-full bg-primary-500 -translate-x-1/2 mt-2 ring-4 ring-background-50"></div>
                    <div className="md:w-1/2 pl-10 md:pl-0 md:px-8">
                      <div className="p-4 rounded-xl bg-background-100 border border-background-200/70">
                        <span className="text-xs font-bold text-primary-600 bg-primary-100 px-2.5 py-0.5 rounded-md whitespace-nowrap">
                          {item.year}
                        </span>
                        <h3 className="font-heading text-base text-foreground-950 mt-2 mb-1">{item.title}</h3>
                        <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 text-center mb-10">
              核心团队
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                  <div className="w-20 h-20 mx-auto rounded-full bg-background-200 flex items-center justify-center mb-4 overflow-hidden">
                    <img
                      src={member.avatar}
                      alt={member.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <h3 className="font-heading text-base text-foreground-950">{member.name}</h3>
                  <p className="text-xs text-primary-600 font-medium mt-1">{member.role}</p>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{member.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 text-center mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              有任何问题或合作意向，欢迎随时与我们联系
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <h4 className="font-heading text-sm text-foreground-950 mb-1">电子邮箱</h4>
                <p className="text-sm text-foreground-600">contact@baicaiwang.com</p>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mb-3">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <h4 className="font-heading text-sm text-foreground-950 mb-1">微信公众号</h4>
                <p className="text-sm text-foreground-600">白菜网站官方</p>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 mb-3">
                  <i className="ri-time-line text-lg"></i>
                </span>
                <h4 className="font-heading text-sm text-foreground-950 mb-1">工作时间</h4>
                <p className="text-sm text-foreground-600">周一至周五 9:00-18:00</p>
              </div>
            </div>

            {/* Contact Form */}
            {formSubmitted ? (
              <div className="text-center py-8 px-6 rounded-xl bg-accent-100 border border-accent-200/70">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-200 text-accent-600 mb-3">
                  <i className="ri-check-line text-xl"></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mb-1">发送成功！</h3>
                <p className="text-sm text-foreground-600">感谢您的留言，我们会尽快回复您。</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="contact-form"
                onSubmit={handleContactSubmit}
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      placeholder="请输入您的姓名"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      placeholder="请输入您的邮箱"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="请输入您的留言内容（最多500字）"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="anti-spam-field"
                />
                {formError && (
                  <p className="text-sm text-red-500">{formError}</p>
                )}
                <button
                  type="submit"
                  className="w-full py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  发送留言
                </button>
              </form>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}